import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
const Structure = (props) => {
    return _jsx(_Fragment, { children: _jsx("div", { className: "d-flex w-100 gap-2", children: Array.from({ 'length': props.state.columns }).map((_, c) => _jsxs("div", { className: "d-flex flex-column flex-grow-1 gap-2", style: { 'width': { 1: '100%', 2: '50%', 3: '33.33%' }[props.state.columns] }, children: [props.state.fields
                        .map((f, i) => [f, i])
                        .filter(([f, _]) => f((x) => !x.hidden))
                        .filter(([f, _]) => f((x) => (x.column || 1) === c + 1 || (c + 1 === 1 && (x.column || 1) > props.state.columns)))
                        .map(([f, i]) => _jsx(React.Fragment, { children: props.renderField(f, i) }, f((x) => x.id))), props.renderColumnFooter && props.renderColumnFooter(c + 1)] }, c)) }) });
};
export default Structure;
